import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import moment from "moment";
import localization from "moment/locale/vi";
var theMoment = moment().local("vi", localization);
export default function Footer() {
  return (
    <Grid
      container
      style={{
        zIndex: 5,
        position: "fixed",
        bottom: 0,
        color: "white",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Typography>
        <Box m={2}>
          {theMoment.format("Do MMM YY")} / {theMoment.format("LT")}
        </Box>
      </Typography>
    </Grid>
  );
}
